import { useParams } from 'react-router-dom'
import React, { useContext } from 'react'
import { Typography } from '@mui/material'
import { com } from '@eidu/form'
import { EntityTypesContext } from '../../../io/context/EntityTypes'
import ImportEntitiesPage from '../ImportEntitiesPage'
import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString

const ImportPageRoute = () => {
  const params = useParams()
  const entityTypeRepository = useContext(EntityTypesContext)

  if (params.entityTypeId) {
    return (
      <ImportEntitiesPage
        entityTypeId={entityTypeIdFromString(params.entityTypeId)}
        entityTypeRepository={entityTypeRepository}
      />
    )
  }

  return <Typography sx={{ padding: 3 }}>Unknown entity type</Typography>
}

export default ImportPageRoute
